module.exports = __webpack_public_path__ + "static/Aston-20197_otebbj-afe686e8b0e8c9b02e794c879b032bf1.jpg";